import gsap from 'gsap'
import $ from 'jquery'
import { elementExists } from './shared'
import { selectors } from './selectors'

const NAV_BURGER_ACTIVE = 'is-active'

const setNavState = {
    opening() {
        $(selectors.blocks.sideMenu).attr('data-navState', 'opening')
        $(selectors.blocks.sideMenuBurger).addClass(NAV_BURGER_ACTIVE)
    },
    open() {
        $(selectors.blocks.sideMenu).attr('data-navState', 'open')
    },
    closed() {
        $(selectors.blocks.sideMenu).attr('data-navState', 'closed')
        $(selectors.blocks.sideMenuBurger).removeClass(NAV_BURGER_ACTIVE)
    },
}

const mm = gsap.matchMedia()

const timeline = gsap.timeline({
    paused: true,
    onStart: setNavState.opening,
    onComplete: setNavState.open,
    onReverseComplete: setNavState.closed,
    defaults: { duration: 0.2 },
})

mm.add(
    {
        isMobile: '(max-width: 576px)',
        isDesktop: '(min-width: 577px)',
    },
    (context) => {
        if (!elementExists(selectors.blocks.sideMenu)) return

        const { isMobile, isDesktop } = context.conditions

        /**
         * Open My account tab by default on mobile
         */
        if (isMobile) {
            $('#nav-client-section').addClass('show')
        }

        if (isDesktop) {
            $('#nav-client-section').removeClass('show')
        }

        const desktop = {
            height: 700,
            display: 'grid',
            ease: 'power2.out',
        }

        const phone = {
            height: 'calc(100vh - 80px)',
            position: 'fixed',
            top: 80,
            left: 0,
            display: 'grid',
            ease: 'power2.out',
        }

        timeline
            .to(selectors.blocks.sideMenu, isMobile ? phone : desktop)
            .to(
                selectors.blocks.sideMenuLinks,
                {
                    opacity: 1,
                    left: 0,
                    stagger: 0.1,
                },
                '<0.2'
            )
            .to(
                selectors.blocks.sideMenuBackdrop,
                {
                    display: 'block',
                    opacity: 0.1,
                },
                '<'
            )
    }
)

export function initHamburgerMenu() {
    const sideMenu_triggers = [selectors.blocks.sideMenuBurger, selectors.blocks.sideMenuClose, selectors.blocks.sideMenuBackdrop]
    if (!elementExists(sideMenu_triggers[0])) return
    sideMenu_triggers.forEach((selector) => $(selector).on('click', toggleSideNavigation))
}

function toggleSideNavigation() {
    const navState = $(selectors.blocks.sideMenu).attr('data-navState')
    switch (navState) {
        case 'open':
            return timeline.seek(0.2).reverse()
        case 'opening':
            return timeline.seek(0.3).reverse()
        case 'closed':
            return timeline.play()
    }
}
